"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationPointsMall',
  data: function data() {
    return {
      loading: false,
      tab: 'goods',
      goodsList: [],
      redeemList: []
    };
  },
  created: function created() {
    this.reload();
  },
  methods: {
    goodsActionText: function goodsActionText(value) {
      return {
        publish: '上架',
        unpublish: '下架',
        redeem: '兑换'
      }[value] || value;
    },
    reload: function reload() {
      var _this = this;
      this.loading = true;
      var req = this.tab === 'goods' ? (0, _decoration.decorationPointsGoodsListApi)({
        page: 1,
        limit: 50
      }) : (0, _decoration.decorationPointsRedeemListApi)({
        page: 1,
        limit: 50
      });
      req.then(function (data) {
        if (_this.tab === 'goods') _this.goodsList = data.list || [];else _this.redeemList = data.list || [];
      }).finally(function () {
        _this.loading = false;
      });
    },
    openCreate: function openCreate() {
      var _this2 = this;
      this.$prompt('商品名称', '新增积分商品').then(function (_ref) {
        var value = _ref.value;
        (0, _decoration.decorationPointsGoodsSaveApi)({
          name: value || 'E2E积分商品',
          pointsPrice: 100,
          stock: 20
        }).then(function () {
          _this2.$message.success('已保存');
          _this2.reload();
        });
      }).catch(function () {});
    },
    runGoods: function runGoods(row, action) {
      var _this3 = this;
      (0, _decoration.decorationPointsGoodsActionApi)(row.goods.id, {
        action: action,
        quantity: 1,
        redeemerName: '后台兑换'
      }).then(function () {
        _this3.$message.success('已更新');
        _this3.reload();
      });
    },
    runRedeem: function runRedeem(row, action) {
      var _this4 = this;
      (0, _decoration.decorationPointsRedeemActionApi)(row.redeem.id, {
        action: action
      }).then(function () {
        _this4.$message.success('已履约');
        _this4.reload();
      });
    }
  }
};